
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24a.5.5 0 01-.5-.5V.5a.5.5 0 011 0v23a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M23.5 12.5H.5a.5.5 0 010-1h23a.5.5 0 010 1z"}})])
          )
        }
      }
    